import { render } from "./NewsTable.vue?vue&type=template&id=43b9d317&scoped=true"
import script from "./NewsTable.vue?vue&type=script&lang=js"
export * from "./NewsTable.vue?vue&type=script&lang=js"

import "./NewsTable.vue?vue&type=style&index=0&id=43b9d317&lang=css"
import "./NewsTable.vue?vue&type=style&index=1&id=43b9d317&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b9d317"]])

export default __exports__